import React, {useContext} from 'react';
import {Controller} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {FormFieldConfigSize} from '@src/@types/components/Form';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import Switch from '@src/components/Fields/Switch';
import {IPaymentTypeModel} from '@src/@interfaces/models/PaymentType/IPaymentTypeModel';

export function IsRequiredField({rowIndex: index, config: {label}}: IListColumnProps) {
    const {
        control,
        fieldName,
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IPaymentTypeModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);

    return <>
        <Controller
                control={control}
                name={`${fieldName}.${index}.is_required`}
                render={({field: {name, value, onChange, onBlur}, fieldState: {error}}) => {
                    return <Switch
                            id={name}
                            label={label}
                            className={classnames({
                                'is-invalid': Boolean(error)
                            })}
                            name={name}
                            bsSize={FormFieldConfigSize.SM}
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={design.fieldsAreDisabled || forceDisabled}
                            checked={value === true}
                            onChange={onChange}
                            onBlur={onBlur}
                    />;
                }}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.is_required`}/>
    </>;
}
